// TODO: Not being used at the moment, needs further checking on how to mount layout with this and route guards
export default {
  namespaced: true,
  state: {
    defaultLayout: 'dashboard',
    layout: 'dashboard'
  },
  mutations: {
    setLayout: (state, payload) => { state.layout = payload },
    resetLayout: (state) => {
      state.layout = state.defaultLayout
  } },
  getters: {
    layout: (state) => `layout-${state.layout}`
  }
}
